/** Media API (upload single/multiple, list, delete). */
import apiClient from '@/services/api/client';

export const listMedia = async () => (await apiClient.get('/v1/media')).data;

export async function uploadMedia(file, { ownerType, ownerId } = {}) {
	const form = new FormData();
	form.append('file', file);
	if (ownerType) form.append('owner_type', ownerType);
	if (ownerId) form.append('owner_id', ownerId);
	const { data } = await apiClient.post('/v1/media', form, {
		headers: { 'Content-Type': 'multipart/form-data' },
	});
	return data;
}

export const deleteMedia = async (id) => apiClient.delete(`/v1/media/${id}`);

/** Absolute URL for a signed (relative) media path. */
export const mediaUrl = (relative) => `${process.env.REACT_APP_BACKEND_URL}${relative}`;
